const headers = {
  name: "Contacts",
  navigate: {
    path: [
      {
        name: "Careers",
        path: "/app/careers",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
